<p-card
  styleClass="very-compact-card"
  header="История">
  @if (loadingHistory) {
    <crm-spinner
      top="mt-4 pb-0 mb-4 pb-4"></crm-spinner>
  }
  @if (!loadingHistory) {
    @if (historyItems?.length) {
      <div
        class="px-3 pb-3 max-h-29rem overflow-auto"
        (scroll)="onScrollEndHistory($any($event.target))">
        <p-timeline
          [value]="historyItems | orderBy: '-created:date'"
          styleClass="history-timeline mt-3">
          <ng-template
            pTemplate="content"
            let-event>
            @if (toItem(event); as event) {
              <div class="flex -mt-2 mb-4">
                @if (event.user) {
                  <crm-user-avatar
                    [user]="event.user"></crm-user-avatar>
                }
                @if (!event.user) {
                  <crm-user-avatar
                    [user]="{ id: -1, profile: { id: '00000000-0000-0000-0000-000000000000', name: 'ФРМ', file: null } }"></crm-user-avatar>
                }
                <div class="w-full ml-3">
                  <div class="font-medium">
                    {{ event.user?.profile?.name || 'ФРМ'
                    }}{{ event.user?.banned || event.user?.deleted ? ' (Заблокирован)' : '' }}
                  </div>
                  <div class="text-400 text-sm">{{ event.created | date: 'dd.MM.yyyy HH:mm' }}</div>
                  <div class="mt-2">
                    <p>{{ event?.label }}</p>
                    @if (event?.oldValue) {
                      <p>{{ event.oldValue }}</p>
                    }
                    @if (event?.newValue) {
                      <p>{{ event.newValue }}</p>
                    }
                  </div>
                </div>
              </div>
            }
          </ng-template>
        </p-timeline>

        @if (paginationLoadingHistory) {
          <div class="text-center">
            <p-progressSpinner
              [style]="{
                width: '50px',
                height: '50px'
              }"></p-progressSpinner>
          </div>
        }
      </div>
    } @else {
      <p class="text-xl font-medium ml-1 p-3">Нет данных</p>
    }
  }
</p-card>
